<template>
  <div
    class="bg-white dark:bg-gray-800 rounded-lg h-auto flex flex-col items-center justify-center w-full p-6 relative"
  >
    <div class="flex justify-between items-center mb-6 w-full">
      <h3 class="text-xl font-bold text-red-600">Delete Account</h3>
      <button
        @click="$emit('close')"
        class="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="space-y-6 w-full">
      <div
        class="bg-red-50 dark:bg-red-900/20 p-4 rounded-lg border border-red-100 dark:border-red-900/30"
      >
        <div class="flex gap-3">
          <div class="text-red-500">
            <i class="fas fa-exclamation-triangle text-xl"></i>
          </div>
          <div>
            <p class="font-medium text-red-700 dark:text-red-400">
              This action cannot be undone
            </p>
            <p class="text-sm text-red-600 dark:text-red-300">
              All your data including stores, products, and transaction history
              will be permanently deleted.
            </p>
          </div>
        </div>
      </div>

      <div>
        <label class="block mb-2 text-sm font-medium dark:text-gray-300"
          >Enter your password to confirm</label
        >
        <input
          v-model="password"
          type="password"
          class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-red-500 focus:border-red-500 dark:bg-gray-700 dark:text-white"
          placeholder="Your account password"
          required
        />
      </div>

      <div class="flex gap-3 pt-4">
        <button
          type="button"
          @click="$emit('close')"
          class="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 py-2 px-4 rounded-lg transition dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200"
        >
          Cancel
        </button>
        <button
          type="button"
          @click="confirmDelete"
          :disabled="!password"
          class="flex-1 bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-lg transition disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Delete Account
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: "",
    };
  },
  methods: {
    confirmDelete() {
      this.$emit("confirm", this.password);
      this.$emit("close");
    },
  },
};
</script>
